<div fxLayout="row wrap" fxLayout.xs="column wrap" style="justify-content: space-between;">
		<div style="margin: 0 !important; width: 100%;" class="pdt-50">
				<h5>{{ 'sprint9.cockpit.card.all.diagramm' | translate }}</h5>
				<h6>{{ 'sprint9.cockpit.card.all.ansichteinstellung' | translate }}</h6>

				<div style="display: flex; justify-content: start; flex-direction: row;">
					<div>
						<mat-button-toggle-group #btngroupAbsolutAnteil="matButtonToggleGroup" appearance="standard"
								id="btnTogglegroupAbsolutAnteil" name="btnTogglegroupAbsolutAnteil" [value]="absolut"
								aria-label="anzhal or Anteil">
								<mat-button-toggle value="{{absolut}}" (change)="selectionAbsolutAnteilChanged($event)">
										<small>{{ 'i18n.common.anzahl' | translate}}</small></mat-button-toggle>

								<mat-button-toggle value="{{anteil}}" (change)="selectionAbsolutAnteilChanged($event)">
									 <small>{{ 'i18n.cockpit.card.chart.gesamtverdienstLohn.anteil' | translate}}</small> </mat-button-toggle>
						</mat-button-toggle-group>
					</div>

					<div class="diagram-margin">
							<mat-button-toggle-group #groupGestapeltUngestepelt="matButtonToggleGroup" appearance="standard"
									id="btnTogglegroupGestapeltUngestepelt" name="btnTogglegroupGestapeltUngestepelt"
									[value]="ungestapelt" aria-label="Ungestepelt or Gestapelt">
									<mat-button-toggle value="{{ungestapelt}}"
											(change)="selectionGestapeltUngestepeltChanged($event)">
											<small>{{ 'i18n.cockpit.card.chart.gesamtverdienstLohn.ungestapelt' | translate}}</small></mat-button-toggle>
									<mat-button-toggle value="{{gestapelt}}"
											(change)="selectionGestapeltUngestepeltChanged($event)">
											<small>{{ 'i18n.cockpit.card.chart.gesamtverdienstLohn.gestapelt' | translate}}</small></mat-button-toggle>
							</mat-button-toggle-group>
					</div>
				</div>

        <div id="svgContainerChartAnzahlAnteilMitarbeitende" class="cockpit-svg-image"></div>
    </div>
</div>
